export function updateSetMembership({ enabled, key, set }) {
  const next = new Set(set)

  if (enabled) {
    next.add(key)
  } else {
    next.delete(key)
  }

  return next
}
